import type { Resolver } from 'cpool-schemas';

import type { SchemaTemplateResolver_GetMailHeaderFooter } from './getMailHeaderFooter';
import { schemaTemplateResolver_GetMailHeaderFooter } from './getMailHeaderFooter';

type Arguments = Record<string, never>;

export const schemaTemplateResolver_GetOwnMailHeaderFooter = schemaTemplateResolver_GetMailHeaderFooter;

export type SchemaTemplateResolver_GetOwnMailHeaderFooter = SchemaTemplateResolver_GetMailHeaderFooter;

export type TemplateResolver_GetOwnMailHeaderFooter = Resolver<
    Arguments,
    SchemaTemplateResolver_GetOwnMailHeaderFooter
>;
